import SlashSelect from './SlashSelect';
import './SlashSelect.scss';

export default SlashSelect;